<template>
  <div>
    <!-- 数据列表 -->
    <el-table :data="pageData"
              row-key="id"
              border
              stripe
              size="mini"
              height="calc(100vh - 115px)"
              default-expand-all
              v-loading="loading">
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="name"
                       label="组织名称">
        <template slot-scope="scope">
          <i class="el-icon-font el-icon-gongsiguanli"
             v-if="scope.row.fatherId == '0'"
             style="margin-right: 4px;color:#409eff"></i>
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lnglat"
                       label="经纬度">
        <template slot-scope="scope">
          <template v-if="scope.row.longitude!=null&&scope.row.latitude!=null">
            <i class="el-icon-location-outline"></i>
            <span>{{ scope.row.longitude+','+scope.row.latitude }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="排序"
                       prop="sortnum">
      </el-table-column>
      <el-table-column label="操作"
                       width="120"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="新增下级组织"
                   type="primary"
                   @click="add_init(scope.row)"><i class="el-icon-font el-icon-web__tianjia"></i></el-link>
          <template v-if="scope.row.fatherId != '0'">
            <el-divider direction="vertical"></el-divider>
            <el-link :underline="false"
                     title="编辑"
                     @click="edit_init(scope.row)"
                     type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
            <el-divider direction="vertical"></el-divider>
            <es-delete @del="del(scope.row.id)"
                       :key="scope.row.id"
                       type="icon"></es-delete>
          </template>
          <span v-else>
            <span style="padding-left:67px"></span>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑框 -->
    <el-dialog :visible.sync="editVisible"
               @closed="() => this.$refs['orgForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑组织
      </span>
      <el-form :model="orgInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="orgForm">
        <el-form-item prop="fatherId"
                      label="上级部门">
          <el-cascader v-if="orgInfo.id != null"
                       v-model="orgInfo.fatherId"
                       :show-all-levels="false"
                       :props="{ value: 'id', checkStrictly: true }"
                       :options="orgTree"
                       filterable
                       style="width:200px"></el-cascader>
          <span v-if="orgInfo.id == null">{{ orgInfo.fatherName }}</span>
        </el-form-item>
        <el-form-item prop="name"
                      label="组织名称">
          <el-input v-model="orgInfo.name"
                    placeholder="请输入组织名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="lnglat"
                      label="经纬度">
          <el-input placeholder="请输入经纬度"
                    style="width:200px"
                    v-model="orgInfo.lnglat">
            <i slot="suffix"
               class="el-icon-location-outline"
               style="cursor:pointer"
               @click="showMap"></i>
          </el-input>
        </el-form-item>

        <el-form-item prop="sortnum"
                      label="排序">
          <el-input v-model="orgInfo.sortnum"
                    placeholder="请输入排序编号"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   :loading="saving"
                   @click="submit()">保 存</el-button>
      </span>
    </el-dialog>
    <!--设备定位-->
    <el-dialog :visible.sync="setLnglatVisible"
               :fullscreen="true"
               style="padding-top: 0px;">
      <span slot="title">
        <i class="el-icon-location-outline el-icon--left"></i>定位设备
      </span>
      <div id="map"
           class="map-class">

      </div>
      <span slot="footer">
        <el-button size="mini"
                   @click="setLnglatVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="setLnglat()">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  name: 'org',
  props: ["funcs"],
  data () {
    return {
      pageData: [],
      editVisible: false,
      orgInfo: {},//组织信息
      rules: {//验证条件
        fatherId: [
          { required: true, message: '请输入上级组织', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入组织名称', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ]
      },
      orgTree: [],
      loading: false,
      saving: false,
      setLnglatVisible: false,
      AMap: null,
      map: null,
      tempLng: null,//临时经度
      tempLat: null,//临时纬度
    }
  },
  methods: {
    init () {
      this.loadList()
    },
    loadList () {
      this.loading = true
      this.$ajax.get('/base/org/list', { orderBy: 'sortnum' }).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //加载组织树
    load_orgTree (id) {
      this.$ajax.get('/base/org/tree_no_self', { id: id }).then(msg => {
        this.orgTree = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    add_init (row) {
      this.editVisible = true
      this.orgInfo = { fatherId: row.id, fatherName: row.name, level: row.level + 1 }
    },
    edit_init (row) {
      this.load_orgTree(row.id)
      this.editVisible = true
      this.orgInfo = JSON.parse(JSON.stringify(row))
      if (row.longitude != null && row.latitude != null) {
        this.orgInfo.lnglat = row.longitude + ',' + row.latitude
      }
    },
    submit () {
      if (this.orgInfo.fatherId != null && Array.isArray(this.orgInfo.fatherId) && this.orgInfo.fatherId.length > 0) {
        this.orgInfo.fatherId = this.orgInfo.fatherId[this.orgInfo.fatherId.length - 1]
      }
      this.$refs["orgForm"].validate(valid => {

        if (valid) {
          let url = "/base/org/add";
          if (this.orgInfo.id != null) {
            url = "/base/org/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.orgInfo).then(msg => {
            this.saving = false
            this.init()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    del (delid) {
      this.loading = true
      this.$ajax.post('/base/org/delete', { 'ids': [delid] }).then(msg => {
        this.loading = false
        this.$message.success(msg)
        this.loadList()
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //显示地图
    showMap () {
      this.setLnglatVisible = true
      this.$ajax.get("/buss/home/load_outline_config").then((msg) => {
        AMapLoader.load({
          key: '204899ccad5874a75849e637df77e6ff',
          version: '2.0',
        }).then((AMap) => {
          this.AMap = AMap
          let minizoom = msg.oneMapLevelMin == null ? msg.twoMapLevelMin : msg.oneMapLevelMin
          let center = this.orgInfo.lnglat != null ? [this.orgInfo.lnglat.split(',')[0], this.orgInfo.lnglat.split(',')[1]] : [msg.centerLongitude, msg.centerLatitude]
          this.map = new AMap.Map('map', {
            zoom: minizoom,
            center: center,
            zooms: [minizoom, msg.threeMapLevelMax]
          })
          this.tempLng = center[0]
          this.tempLat = center[1]
          let marker = new this.AMap.Marker({
            position: center,
            icon: require('../../assets/imgs/location_asset_b_19x31.png'),
            anchor: 'bottom-center',
            label: { content: this.orgInfo.name, direction: 'top' },
            draggable: true
          });
          marker.on('dragend', (p) => {
            let pixel = new AMap.Pixel(p.pixel.x, p.pixel.y + 15.5)
            let position = this.map.containerToLngLat(pixel)
            this.tempLng = position.lng
            this.tempLat = position.lat
          })
          this.map.add(marker)

        }).catch(e => {
          console.log(e);
        })

      }).catch((err) => {
        this.$message.error(err);
      });
    },
    //确定定位
    setLnglat () {
      this.setLnglatVisible = false
      this.orgInfo.lnglat = this.tempLng + ',' + this.tempLat
      this.orgInfo.longitude = this.tempLng
      this.orgInfo.latitude = this.tempLat
    },
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>
.map-class {
  width: 100%;
  height: calc(100vh - 118px);
}
</style>
